export * from './auth';
export * from './auth_backend';
export * from './firebase_sdk_auth_backend';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angularfire2/auth/index.js
// module id = 221
// module chunks = 2